module.exports = __webpack_public_path__ + "static/media/bg-things-you-will-love.dd32913f.png";